export default function ModifyReportCriteriaIcon({ className, color = 'currentColor', size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15.25 15.25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.5625 0.5H1.6875C1.03166 0.5 0.5 1.03166 0.5 1.6875V13.5625C0.5 14.2183 1.03166 14.75 1.6875 14.75H13.5625C14.2183 14.75 14.75 14.2183 14.75 13.5625V1.6875C14.75 1.03166 14.2183 0.5 13.5625 0.5Z"
        stroke={color}
        strokeLinejoin="round"
      />
      <path
        d="M0.5 4.85417H14.75M4.85417 14.75V4.85417"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

